<template>
  <el-dialog :title="title" :visible.sync="visible" :lock-scroll="true" width="718px" :before-close="handleClose">
    <div class="">
      <div style="padding: 24px 0;">
        <el-form ref="form-data" :model="form" :inline="false" label-width="150px" label-position="right" :rules="rules"
          style="text-align:left;">
          <el-form-item prop="amount" label="打款金额">
            <el-input v-model.tirm="form.amount" style="width: 400px;" placeholder="请输入" clearable size="small"
              :maxlength="3" :disabled="true" class="amount">
              <template slot="prefix">
                <span class="qty">￥</span>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="remitTime" label="汇款日期">
            <el-date-picker v-model="form.remitTime" style="width: 400px;" value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime" placeholder="选择日期" :disabled="true" />
          </el-form-item>

          <el-form-item prop="remitNo" label="打款尾号">
            <el-input v-model.tirm="form.remitNo" style="width: 400px;" placeholder="请输入" clearable size="small"
              :maxlength="8" :disabled="true" />
          </el-form-item>

          <el-form-item prop="remitTitle" label="打款抬头">
            <el-input v-model.tirm="form.remitTitle" style="width: 400px;" placeholder="请输入" clearable size="small"
              :disabled="true" show-limit-word max-length="50" />
          </el-form-item>

          <el-form-item prop="fileList" label="打款凭证">
            <div class="file-upload">
              <fileUpload v-model="form.fileList" @onRemoveHandler="onRemoveHandler" :isEdit="true" style="width: 400px;"
                v-if="fileListShow"></fileUpload>
            </div>
          </el-form-item>

          <el-form-item label="审核意见" v-if="pageType == 'detail'">
            <el-input v-model.tirm="form.remarks" style="width: 400px;" placeholder="" clearable size="small"
              type="textarea" show-limit-word max-length="200" :disabled="true" />
          </el-form-item>

          <el-form-item>
            <div class="footer-btn">
              <el-button size="small" type="primary" @click="audit()" :disabled="isDisabled"
                v-if="form.status == 'submit' && pageType != 'detail'">审核通过</el-button>
              <el-button size="small" type="primary" @click="rejectShow()" :disabled="isDisabled"
                v-if="form.status == 'submit' && pageType != 'detail'">驳回</el-button>
              <el-button size="small" type="plain" @click="handleClose()">返回</el-button>
            </div>
          </el-form-item>
        </el-form>

      </div>
    </div>

    <el-dialog width="708px" top="25vh" title="审核" :visible.sync="innerVisible" append-to-body :before-close="handleCancle">
      <el-form ref="form-data" :model="form" :inline="false" label-width="150px" label-position="right">
        <el-form-item label="审核意见">
          <el-input v-model.tirm="form.remarks" style="width: 300px;" placeholder="" clearable size="small"
            type="textarea" show-limit-word max-length="200" :disabled="isDisabled" />
        </el-form-item>
        <el-form-item>
          <div class="footer-btn">
            <el-button size="small" type="primary" @click="reject()" :disabled="isDisabled">确认驳回</el-button>
            <el-button size="small" type="plain" @click="handleCancle()" :disabled="isDisabled">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
    
<script>
import fileUpload from "@/components/fileUpload";
import { platformApprove, platformApproveInfo } from "@/api/surety";
import avater from "/public/img/default.png";
import imgUpload from '@/components/imgUpload';
export default {
  props: {},
  components: { imgUpload, fileUpload },

  data() {
    return {
      fileListShow: true,
      innerVisible: false,
      avater: avater,
      disabled: false,
      id: '',
      pageType: '',
      isDisabled: false,
      form: {
        fileList: [],
        remarks: "",///审核意见 
      },
      rules: {
        remarks: [{ required: true, message: '请填写审核意见', trigger: 'blur' }],
      },
      title: '',
      visible: false,
    }
  },
  created() {

  },
  mounted() {

  },
  watch: {},
  methods: {

    onRemoveHandler(file) {
      console.log(file)
    },
    
    // 审核通过

    handleCancle() {
      this.innerVisible = false;
      this.remarks = ""
    },


    rejectShow() { 
      this.innerVisible = true; 
    },

    // 生成params对象的方法  
    createParams(withRemarks = false) {
      let params = {
        "approveId": this.form.approveId,
      };
      if (withRemarks) {
        params["remarks"] = this.form.remarks;
      }
      return params;
    },

    audit() {
      let params = this.createParams();
      params["status"] = 'pass';
      this.submit(params);
    },

    reject() {
      let params = this.createParams(true);
      params["status"] = 'fail';
      this.submit(params);
    },

    submit(params) {
      let formData = this.$refs['form-data'];
      if (formData) {
        formData.validate((valid) => {
          if (valid) {
            platformApprove(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');
                this.$emit('getList');
                this.handleClose();
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        });
      }
    },
    handleClose() {
      Object.keys(this.form).forEach((key) => (this.form[key] = ""));
      this.form.fileList = [];
      this.$refs['form-data'].resetFields();
      this.visible = false;
      this.innerVisible = false;
    },
    init(row, type) {
      this.title = '保证金充值';
      this.pageType = type;
      if (type == 'detail') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (row && row.id) {
        this.query(row.id);
      } else {
        this.visible = true;
      }
      this.$forceUpdate();
    },
    query(id) {
      this.form.fileList = [];
      this.form.approveId = id;
      this.fileListShow = false;
      platformApproveInfo({ id: id }).then(res => {
        this.form = Object.assign(this.form, res);
        if (this.form.amount) {
          this.form.amount = this.form.amount.toFixed(2)
        }
        // 创建一个数组，包含证书名称  
        var certs = ['cert', 'cert2', 'cert3'];

        // 遍历数组  
        for (var i = 0; i < certs.length; i++) {
          var cert = res[certs[i]];
          if (cert) {
            this.form.fileList.push({
              url: cert,
              name: cert.indexOf('http') != -1 ? cert.substring(cert.lastIndexOf('/') + 1, cert.length) : cert,
              "status": "success"
            });
          }
        }
        this.fileListShow = true;
        this.visible = true;
      })
    }, 
  }
}

</script>
<style lang="scss" scoped>
.eachRow {
  background-color: #fff;
  border-radius: 4px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}

.titleView {
  display: flex;
  align-items: center;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }

  .cpxhead {
    display: flex;
    align-items: center;
  }

  .mark {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
    width: 200px;
    line-height: 1.5;
    display: inline-block;
    font-weight: bold;
  }
}

.goods-list-warp {
  width: 100%;
  margin-left: 100px;
  max-height: 500px;
  overflow-y: auto;
}

.goods-list {
  width: 50%;
  border-bottom: solid 1px #f5f5f5;
  padding-bottom: 10px;

  &:nth-last-child(1) {
    border-bottom: none;
  }
}

.footer-btn {
  width: 410px;
  display: flex;
  justify-content: space-between;
}

.amount ::v-deep .el-input__prefix {
  //color: #666;
  font-size: 16px;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 30px;
}

.file-upload {
  min-height: 60px;
}
</style>
  
  